/**
 * Build ordered DSCC status options for <select> (value = lookup row id).
 * If currentId is set but not in the list (e.g. row deleted), prepend a placeholder option.
 */
export function mergeDsccStatusLookupForSelect(lookupRows, currentId) {
  const rows = Array.isArray(lookupRows)
    ? [...lookupRows].sort((a, b) => {
        const so = (a.sort_order ?? 0) - (b.sort_order ?? 0);
        if (so !== 0) return so;
        return String(a.display_name || '').localeCompare(String(b.display_name || ''), undefined, { sensitivity: 'base' });
      })
    : [];
  const idStr = currentId != null && currentId !== '' ? String(currentId) : '';
  if (idStr && !rows.some((r) => String(r.id) === idStr)) {
    return [
      { id: currentId, code: '__orphan__', display_name: `Unknown status (id ${idStr})`, sort_order: -9999 },
      ...rows,
    ];
  }
  return rows;
}
